import Lang from "lib/localization/lang";

/**
	* Fetches language data by id
	*
	* @param id			-	String id
	* @param values 	-	Replacement strings (optional)
	*
	* @returns 
	* The requested language string if it exists with optional replacements. 
	* Replaces every `%` within `id` with `values.shift()`
	* It id is not found in language strings map, it returns `{id}`.
*/
export function getLocaleString(id:string, values:Array<string> = [], placeholderEnabled:boolean = true):string {
	let str = _config.lang?.strings.get(id) || (placeholderEnabled ? `{${id}}` : null);
	
	if(!str)
		return null;
	
	return str.replace(/%/g, (match:string) => values.shift());
}

/**
	* Get lang instance of language id
	*
	* @param id		-	Language id (e.g. en_GB)
	*
	* @returns
	* Lang instance with language id data
*/
export function getLang(id:string):Lang {
	return new Lang(id);
}